// Phase 1A Step 34 — Section 05 The Intelligence Edge.
// Verbatim port from handoff/landing-reference/sections.jsx EdgeSection.
// House vs STRIKZA — three rows comparing bookmaker mechanics with our counters.

import { EDGE_ROWS } from "./landing-data.ts";

export function EdgeSection(): JSX.Element {
  return (
    <section
      className="sz-l-section"
      style={{ padding: "160px 0", borderTop: "1px solid var(--border)" }}
    >
      <div className="container">
        <div
          className="sz-l-section-header"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.6fr",
            gap: 80,
            marginBottom: 60,
          }}
        >
          <div>
            <span className="bracket">Section 05 · Edge</span>
          </div>
          <div>
            <h2
              className="serif"
              style={{
                fontSize: "clamp(40px, 5vw, 68px)",
                fontWeight: 500,
                lineHeight: 1.02,
                color: "var(--text)",
                marginBottom: 22,
                letterSpacing: "-0.01em",
              }}
            >
              What the house does.
              <br />
              <em style={{ color: "var(--accent)", fontStyle: "italic" }}>What we do back.</em>
            </h2>
            <p
              style={{
                fontSize: 17,
                color: "var(--text-muted)",
                maxWidth: 640,
                lineHeight: 1.55,
              }}
            >
              Sportsbooks aren&apos;t casinos. They&apos;re trading desks dressed as entertainment.
              We built STRIKZA to compete on the same plane — math, latency, discipline.
            </p>
          </div>
        </div>

        <div
          style={{ display: "flex", flexDirection: "column", border: "1px solid var(--border)" }}
        >
          {/* Header */}
          <div
            className="sz-l-edge-header"
            style={{
              display: "grid",
              gridTemplateColumns: "260px 1fr 1fr",
              background: "var(--surface)",
              borderBottom: "1px solid var(--border)",
            }}
          >
            <div style={{ padding: "18px 24px" }}>
              <span className="eyebrow-muted">Mechanic</span>
            </div>
            <div style={{ padding: "18px 24px", borderLeft: "1px solid var(--border)" }}>
              <span
                className="mono"
                style={{
                  fontSize: 11,
                  letterSpacing: "0.18em",
                  color: "var(--text-muted)",
                  textTransform: "uppercase",
                }}
              >
                The House
              </span>
            </div>
            <div
              style={{
                padding: "18px 24px",
                borderLeft: "1px solid var(--accent-deep)",
                background: "rgba(212, 168, 67, 0.05)",
              }}
            >
              <span
                className="mono"
                style={{
                  fontSize: 11,
                  letterSpacing: "0.18em",
                  color: "var(--accent)",
                  textTransform: "uppercase",
                }}
              >
                STRIKZA
              </span>
            </div>
          </div>

          {EDGE_ROWS.map((row, i) => (
            <div
              key={i}
              className="sz-l-edge-row"
              style={{
                display: "grid",
                gridTemplateColumns: "260px 1fr 1fr",
                borderBottom: i < EDGE_ROWS.length - 1 ? "1px solid var(--border)" : "0",
                minHeight: 180,
              }}
            >
              <div style={{ padding: "32px 24px", background: "var(--surface)" }}>
                <span
                  className="mono"
                  style={{
                    fontSize: 10,
                    letterSpacing: "0.18em",
                    color: "var(--text-dim)",
                    textTransform: "uppercase",
                  }}
                >
                  0{i + 1}
                </span>
                <div
                  className="serif"
                  style={{
                    fontSize: 26,
                    fontWeight: 500,
                    fontStyle: "italic",
                    color: "var(--text)",
                    marginTop: 14,
                    lineHeight: 1.15,
                  }}
                >
                  {row.topic}
                </div>
              </div>
              <div
                style={{
                  padding: "32px 24px",
                  borderLeft: "1px solid var(--border)",
                  color: "var(--text-muted)",
                  fontSize: 15,
                  lineHeight: 1.55,
                }}
              >
                {row.house}
              </div>
              <div
                style={{
                  padding: "32px 24px",
                  borderLeft: "1px solid var(--accent-deep)",
                  background: "rgba(212, 168, 67, 0.03)",
                  color: "var(--text)",
                  fontSize: 15,
                  lineHeight: 1.55,
                }}
              >
                {row.strikza}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
